export const Views = () => ({});
export default Views;
